/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.SYMBIAN_INDEX = {

  '@': 
  [
     '(?i)U1(a|i|iv)?$!',
     '(?i)U5(a|i|iv)?$!',
     '(?i)U8(a|i)?$!',
  ],
  '@32': 
  [
     3230,
     3250,
  ],
  '@36': 
  [
     3650,
     3660,
  ],
  '@50': 
  [
     500,
  ],
  '@52': 
  [
     5228,
     '5233!',
     '5230!',
     5232,
     '5235!',
     5236,
     5238,
     5250,
  ],
  '@53': 
  [
     '5320!',
  ],
  '@55': 
  [
     '5500d!',
     '5530!',
  ],
  '@56': 
  [
     '5630!',
  ],
  '@57': 
  [
     '5700!',
     '5730!',
  ],
  '@58': 
  [
     '5800!',
  ],
  '@60': 
  [
     600,
     603,
  ],
  '@61': 
  [
     '6110Navigator',
     '6120c!',
     '6121c!',
     '6122c!',
     '6124c',
  ],
  '@62': 
  [
     '6210 ?Navigator!',
     '6220c!',
     6260,
     '6290!',
  ],
  '@66': 
  [
     6600,
     6630,
     '6650d!',
     6670,
     6680,
     6681,
  ],
  '@67': 
  [
     '6700s',
     '6700s-1c',
     6708,
     '6710s',
     '6720c!',
     '6730c!',
     '6760s!',
     6788,
     '6788i',
     '6790s-1b!',
     '6790s-1c!',
  ],
  '@70': 
  [
     700,
     701,
     '702T',
  ],
  '@76': 
  [
     7610,
     7650,
     7660,
  ],
  '@80': 
  [
     '801T',
     808,
     '808PureView',
     '808 PureView',
  ],
  '@A1': 
  [
     'A1000',
  ],
  '@A9': 
  [
     'A920',
     'A925',
  ],
  '@BE': 
  [
     'BenQ P30',
     'BenQ P31',
  ],
  '@C5': 
  [
     'C5-00!',
     'C5-01',
     'C5-03!',
     'C5-04',
     'C5-05',
     'C5-06',
  ],
  '@C6': 
  [
     'C6-00!',
     'C6-01!',
  ],
  '@C7': 
  [
     'C7-00!',
  ],
  '@CO': 
  [
     'ConstellationT',
     'ConstellationQuest',
  ],
  '@E-': 
  [
     'E-90-1',
  ],
  '@E5': 
  [
     'E5-00!',
     'E50(-[1-9])?$!',
     'E51(-[1-9])?$!',
     'E52(-[1-9])?$!',
     'E55(-[1-9])?$!',
  ],
  '@E6': 
  [
     'E6',
     'E6-00',
     'E60(-[1-9])?$!',
     'E61i!',
     'E61(-[1-9])?$!',
     'E62(-[1-9])?$!',
     'E63(-[1-9])?$!',
     'E65(-[1-9])?$!',
     'E66(-[1-9])?$!',
  ],
  '@E7': 
  [
     'E7-00',
     'E70(-[1-9])?$!',
     'E71x',
     'E71(-[1-9])?$!',
     'E72(-[1-9])?$!',
     'E73(-[1-9])?$!',
     'E75(-[1-9])?$!',
  ],
  '@E9': 
  [
     'E90(-[1-9])?$!',
  ],
  '@G7': 
  [
     'G700',
  ],
  '@G9': 
  [
     'G900',
  ],
  '@I7': 
  [
     'I7710',
  ],
  '@I8': 
  [
     'I8510',
     'I8910',
  ],
  '@LG': 
  [
     'LG KS10',
     'LGKT610',
     'LGKT615',
  ],
  '@M1': 
  [
     'M1000',
  ],
  '@M6': 
  [
     'M600i',
  ],
  '@N-': 
  [
     'N-Gage',
     'N-GageQD',
  ],
  '@N5': 
  [
     'N5233!',
  ],
  '@N7': 
  [
     'N70(-[1-9])?$!',
     'N71(-[1-9])?$!',
     'N72(-[1-9])?$!',
     'N73(-[1-9])?$!',
     'N75(-[1-9])?$!',
     'N76(-[1-9])?$!',
     'N77(-[1-9])?$!',
     'N78(-[1-9])?$!',
     'N79(-[1-9])?$!',
  ],
  '@N8': 
  [
     'N8-00',
     'N80(-[1-9])?$!',
     'N81(-[1-9])?$!',
     'N82(-[1-9])?$!',
     'N85(-[1-9])?$!',
     'N86(-[1-9])?$!',
     'N86 ?8MP$!',
  ],
  '@N9': 
  [
     'N90(-[1-9])?$!',
     'N91(-[1-9])?$!',
     'N92(-[1-9])?$!',
     'N93(-[1-9])?$!',
     'N93i',
     'N95(-[1-9])?$!',
     'N95[ -]8GB(-[1-9])?!',
     'N96(-[1-9])?$!',
     'N97(-[1-3])?$!',
     'N97i',
     'N97(-[4-5])?$!',
     'N97 ?mini!',
  ],
  '@NO': 
  [
     'Nokia N81',
     'Nokia N81 8GB',
  ],
  '@OR': 
  [
     'Oro',
  ],
  '@P1': 
  [
     'P1i',
  ],
  '@P9': 
  [
     'P910i',
     'P990i',
  ],
  '@PA': 
  [
     'Panasonic-X700',
     'Panasonic-X800',
  ],
  '@RI': 
  [
     'RIZR-Z8',
     'RIZR-Z10',
  ],
  '@SG': 
  [
     'SGH-D720',
     'SGH-D728',
     'SGH-D730',
     'SGH-i400!',
     'SGH-i408!',
     'SGH-i450!',
     'SGH-i455!',
     'SGH-i458!',
     'SGH-i520!',
     'SGH-i550!',
     'SGH-i560!',
     'SGH-i568!',
     'SGH-i570!',
     'SGH-G810',
  ],
  '@T7': 
  [
     'T7-00',
  ],
  '@U': 
  [
     'U',
  ],
  '@W9': 
  [
     'W950i',
     'W960i',
  ],
  '@X5': 
  [
     'X5-00',
     'X5-01',
  ],
  '@X6': 
  [
     'X6-00!',
  ],
  '@X7': 
  [
     'X7-00!',
  ],
};

/* This file is automatically generated, do not edit manually! */
